module.exports = __webpack_public_path__ + "img/send-email.9a29d137.svg";